import {
  CONFIG_SERVICE_KEYS,
  FEATURE_DECISION_KEYS,
} from '@web-platform/shared-universal-constants-config';
import {
  getConfigServiceValue,
  getFeatureDecision,
} from '@web-platform/shared-universal-utils-frontend/src/config';

import {
  getParallelSearchOptionLabel,
  getPackagesParallelSearchOptionLabel,
} from './getParallelSearchOptionLabel';

import type { FlightsSearchControlsProps } from '@skyscanner-internal/global-components/flights-search-controls';

type FeatureDecisions = FlightsSearchControlsProps['featureDecisions'];

/**
 * Gets feature decisions for the Flights Search Controls component (Banana).
 * @param {boolean} enableParallelSearchOption - Parallel Search Feature flag.
 * @param {boolean} enablePackagesParallelSearchOption - Packages Parallel Search Feature flag.
 * @returns {FeatureDecisions} An object containing feature decisions for the Flights Search Controls component.
 */
export const getFeatureDecisions = (
  enableParallelSearchOption: boolean,
  enablePackagesParallelSearchOption = false,
): FeatureDecisions => ({
  autosuggestExpVal: getConfigServiceValue(CONFIG_SERVICE_KEYS.EXPERIMENT.AUTOSUGGEST_EXP),
  enableCalendarPrices: getFeatureDecision(FEATURE_DECISION_KEYS.ENABLE_CALENDAR_PRICES),
  enableCalendarPricing: getConfigServiceValue(CONFIG_SERVICE_KEYS.OPS.ENABLE_PRICE_CALENDAR_DATA),
  enableCalendarPricesV2Endpoints: getFeatureDecision(
    FEATURE_DECISION_KEYS.ENABLE_CALENDAR_PRICES_V2_ENDPOINTS,
  ),
  enableCalendarPricesProgressiveLoadingMobile: getFeatureDecision(
    FEATURE_DECISION_KEYS.ENABLE_CALENDAR_PRICES_PROGRESSIVE_LOADING_MOBILE,
  ),
  enableCalendarPricesProgressiveLoadingDesktop: getFeatureDecision(
    FEATURE_DECISION_KEYS.ENABLE_CALENDAR_PRICES_PROGRESSIVE_LOADING_DESKTOP,
  ),
  enableEnforceTripType: getFeatureDecision(FEATURE_DECISION_KEYS.ENABLE_ENFORCE_TRIP_TYPE),
  enableFlexibleDateSelectionWithBackToDepart: getFeatureDecision(
    FEATURE_DECISION_KEYS.ENABLE_FLEXIBLE_DATE_SELECTION_WITH_BACK_TO_DEPART,
  ),
  enableFlexibleDateSelectionWithStickToReturn: getFeatureDecision(
    FEATURE_DECISION_KEYS.ENABLE_FLEXIBLE_DATE_SELECTION_WITH_STICK_TO_RETURN,
  ),
  enableParallelSearchMultiLine: getFeatureDecision(
    FEATURE_DECISION_KEYS.ENABLE_PARALLEL_SEARCH_MULTI_LINE,
  ),
  enableParallelSearchOption,
  parallelSearchOptionLabel: getParallelSearchOptionLabel(),
  enablePackagesParallelSearchOption,
  packagesParallelSearchOptionLabel: enablePackagesParallelSearchOption
    ? getPackagesParallelSearchOptionLabel()
    : undefined,
  parallelSearchOptionPosition: getFeatureDecision(
    FEATURE_DECISION_KEYS.PARALLEL_SEARCH_OPTION_POSITION,
  ),
  bagsExpVal: getConfigServiceValue(CONFIG_SERVICE_KEYS.EXPERIMENT.BAGS_EXP),
  enableBaggageSelect: getFeatureDecision(FEATURE_DECISION_KEYS.ENABLE_BAGGAGE_SELECT),
});
